define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/FormData",
	"csi/action/Controller",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"./StyleAttributeMapping/StylePushTemplatesForm"
], function(declare,lang,FormData,Controller,ActionControllerMixin,xml) {

	return declare([Controller, ActionControllerMixin], {

		FIELD_MERCH_PRODUCT_SUBTYPE: "MerchProductSubtype",
		FIELD_TEMPLATE: "Template",
		nodeURL: null,

		getFormData: function() {
			var	data = this.inherited(arguments);
			data.m_bRequireOne = true;
			data.m_bSelectOne = true;
			return data;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			var nPage = wizard.getIndexOfPage(nextPage);
			var	fd = this.m_formData;
			if (nPage == 0) {
				fd.m_bRequireOne = true;
				fd.m_bSelectOne = true;
			}
			this.nodeURL = fd.getFieldValue(this.FIELD_TEMPLATE);
			return wizard.carryOverFormData(currentPage, nextPage);
		},

		toWriterRequest: function(/*FormData?*/fd) {
			// summary: handle request for second page
			var	call = this.inherited(arguments);
			call.addParameter("Template", xml.ATTR_REF, this.nodeURL);
			return call;
		}
	});
});